import {
  getMergeConnectorCapability,
  getMergeConnectorLabel,
  getNangoProviderDescription,
  getNangoProviderLabel,
  MERGE_ALLOWED_CONNECTORS,
  NANGO_ALLOWED_INTEGRATIONS,
} from '@heidi/integrations/connected-apps/contracts';

import type {
  ConnectAppOption,
  ConnectAppStack,
} from '../../../contracts/projects/integrations/connectAppChips.defaults';
import { resolveProjectConnectAppOptions } from '../../../data/projects/integrations/connectAppChips.defaults';
const MERGE_ALLOWED = new Set<string>(MERGE_ALLOWED_CONNECTORS);
const NANGO_ALLOWED = new Set<string>(NANGO_ALLOWED_INTEGRATIONS);

const connectAppLabel = (id: string, stack: ConnectAppStack): string =>
  stack === 'nango' ? getNangoProviderLabel(id) : getMergeConnectorLabel(id);

export const resolveConnectAppOptions = (
  connectors: readonly ConnectAppOption[] | readonly string[],
  stack: ConnectAppStack
): ConnectAppOption[] =>
  resolveProjectConnectAppOptions(connectors, stack, {
    allowed: stack === 'nango' ? NANGO_ALLOWED : MERGE_ALLOWED,
    label: (id) => connectAppLabel(id, stack),
  });
/**
 * Clinician-facing "what Heidi can do once this is connected" line — the same
 * copy the Connected apps settings list shows, so the in-chat prompt and the
 * settings catalog make the same promise.
 */
export const connectAppCapability = (id: string, stack: ConnectAppStack): string =>
  stack === 'nango' ? getNangoProviderDescription(id) : getMergeConnectorCapability(id);
